import React, { useState } from "react";
import accessURL from "../../../components/utils/superAccess";
import { Loader2 } from "lucide-react";

const allDurations = [
  { value: "1month", label: "1 Month" },
  { value: "2months", label: "2 Months" },
  { value: "3months", label: "3 Months" },
  { value: "4months", label: "4 Months" },
  { value: "5months", label: "5 Months" },
  { value: "6months", label: "6 Months" },
  { value: "7months", label: "7 Months" },
  { value: "8months", label: "8 Months" },
  { value: "9months", label: "9 Months" },
  { value: "10months", label: "10 Months" },
  { value: "11months", label: "11 Months" },
  { value: "1year", label: "1 Year" },
];

const SetTrial: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState(
    allDurations[0].value
  );
  const [isLoading, setIsLoading] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const res = await accessURL.post(`super-admin/setTrial`, {
        selectedDuration,
      });

      if (res.data.status === "success" && res.data.code === 200) {
        // Close modal and refresh page on success
        closeModal();
        window.location.reload();
      }
    } catch (error) {
      console.error("Error setting trial:", error);
      // You might want to show an error message to the user here
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center">
      <button
        onClick={openModal}
        className="px-6 py-2 text-white bg-black border border-black rounded-md hover:bg-gray-800 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-black focus:ring-opacity-50"
      >
        Set Trial
      </button>

      {/* Modal Backdrop */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          {/* Modal Content */}
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 mx-4">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-gray-900">
                Set Trial Duration
              </h3>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-500 focus:outline-none"
                disabled={isLoading}
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="mb-6">
              <label
                htmlFor="duration"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Select Duration
              </label>
              <select
                id="duration"
                value={selectedDuration}
                onChange={(e) => setSelectedDuration(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                disabled={isLoading}
              >
                {allDurations.map((duration) => (
                  <option key={duration.value} value={duration.value}>
                    {duration.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={closeModal}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black focus:ring-opacity-50"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isLoading}
                className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-black focus:ring-opacity-50 flex items-center justify-center min-w-[80px]"
              >
                {isLoading ? (
                  <Loader2 className="h-5 w-5 animate-spin" />
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetTrial;
